import React from 'react';
import withPageComponents from '../../../page/components/with-page-components';
import ICTOConfigId from './icto-config-id';
import { TARGET_CATGORIES } from './product-identity-details';

const EMPTY_OBJ = {};

export const getCTOConfigDetails = (baseConfig, ctoProductInitial, ctoPrice, seo) => {
    const { specCategories = [] } = baseConfig || EMPTY_OBJ;
    const base = specCategories.find(item => item.title === 'Base' || item.title === 'Base features');
    const baseSku = base?.optionitems.find(l => l.selected === 'true')?.sku || '';

    const { ctoConfiguration } = ctoPrice || EMPTY_OBJ;
    let { iCTO, configID } = ctoConfiguration || EMPTY_OBJ;
    const { canonical } = seo || EMPTY_OBJ;

    const displayBaseSku = ctoPrice?.ctoConfiguration !== undefined;

    if (displayBaseSku && canonical && canonical.includes('/custom/')) {
        const validConfigID = canonical.includes('_') ? canonical.split('/').pop().split('?')[0].split('-').pop() : '';
        configID = validConfigID.includes('_') ? validConfigID : null;
    }
    const displayProdNumber = TARGET_CATGORIES?.map(c => c.toLowerCase()).includes(
        ctoProductInitial?.pm_category?.toLowerCase()
    );
    const ctoConfig = {
        ...(displayProdNumber ? { iCTO } : {}),
        ...(configID ? { configID } : {}),
        ...(displayBaseSku ? { baseSku } : {}),
    };
    return ctoConfig;
};

export default withPageComponents(
    ({ baseConfig, ctoProductInitial, ctoPrice, seo }) => {
        const { iCTO, configID, baseSku } = getCTOConfigDetails(baseConfig, ctoProductInitial, ctoPrice, seo);
        return <ICTOConfigId className="pdp-cto-config" iCTO={iCTO} configID={configID} baseSku={baseSku} />;
    },
    {
        components: ['baseConfig', 'ctoProductInitial', 'ctoPrice', 'shipDate'],
        seo: true,
        device: true,
    }
);
